define('TescoMobile_DataLayer/js/view/monthly-payment-step-mixin',['jquery'], function ($) {
  'use strict';

  var mixin = {
    creditCheckDeclinedScreen: function () {
      let showSimoDeals = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (showSimoDeals && !this.isMultiItemBasket()) {
        $('body').trigger('dl-checkout-idv-failed-show-alternative-deals');
      } else {
        $('body').trigger('dl-checkout-idv-failed-without-alternative-deals');
      }
      return this._super(showSimoDeals);
    },
    setKbaContent: function (content, contentType, hasVisibleButton) {
      if (contentType === 'kbaError') {
        $('body').trigger('dl-checkout-kba-content-error');
      }
      return this._super(content, contentType, hasVisibleButton);
    },
    creditCheckReferredScreen: function (response) {
      $('body').trigger('dl-checkout-credit-check-referred');
      return this._super(response);
    }
  };
  return function (target) {
    return target.extend(mixin);
  };
});

